import { createContext } from 'react';

const QuickOrderQuantityCellContext = createContext(null);

export default QuickOrderQuantityCellContext;
